import { List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// state
const initialState = fromJS({
  data: [],
  min: null,
  max: null,
  step: 0,
  diffDate: null,
  types: [],
})

// constants
export const SATELLITE_LIST = 'satellite/SATELLITE_LIST'
export const [SATELLITE_LIST_SUCCESS, SATELLITE_LIST_FAILURE] = [
  `${SATELLITE_LIST}_SUCCESS`,
  `${SATELLITE_LIST}_FAILURE`,
]

export const SATELLITE_TYPE_LIST = 'satellite/SATELLITE_TYPE_LIST'
export const [SATELLITE_TYPE_LIST_SUCCESS, SATELLITE_TYPE_LIST_FAILURE] = [
  `${SATELLITE_TYPE_LIST}_SUCCESS`,
  `${SATELLITE_TYPE_LIST}_FAILURE`,
]

export const satelliteList = ActionHelper.createActionObj(SATELLITE_LIST)
export const satelliteTypeList = ActionHelper.createActionObj(
  SATELLITE_TYPE_LIST,
)

// reducers
const satellite = handleActions(
  {
    [SATELLITE_LIST_SUCCESS]: (state, action) =>
      state
        .set('data', List(action.payload.data))
        .set('min', action.payload.min)
        .set('max', action.payload.max)
        .set('step', action.payload.step)
        .set('diffDate', action.payload.diffDate),
    [SATELLITE_TYPE_LIST_SUCCESS]: (state, action) =>
      state.set('types', List(action.payload)),
    [RESET_STORE]: () => initialState,
  },
  initialState,
)

export default satellite
